const UserFeedCardSkeleton = () => {
  return (
    <div className="relative mb-[15px] h-fit w-full max-w-[calc(100vw-40px)] rounded-2xl shadow-sm md:min-w-[325px] md:max-w-none">
      <div className="overflow-hidden rounded-2xl border border-lightBorder bg-white">
        <div className="flex flex-col p-4">
          <div className="flex items-start justify-between">
            <div className="flex items-center gap-3">
              <div className="size-[35px] animate-pulse rounded-full bg-gray-200" />
              <div className="flex flex-col gap-0.5">
                <div className="flex items-center gap-1 text-base">
                  <div className="h-4 w-20 animate-pulse rounded bg-gray-200" />
                  <div className="h-3 w-16 animate-pulse rounded bg-gray-200" />
                </div>
                <div className="flex items-center gap-0.5">
                  <div className="h-3 w-14 animate-pulse rounded bg-gray-200" />
                  <div className="h-3 w-10 animate-pulse rounded bg-gray-200" />
                </div>
              </div>
            </div>
            <div className="flex items-start gap-1">
              <div className="h-3 w-12 animate-pulse rounded bg-gray-200" />
            </div>
          </div>
          <div className="mt-3 h-4 w-full animate-pulse rounded bg-gray-200" />
          <div className="mt-2 h-4 w-3/4 animate-pulse rounded bg-gray-200" />
        </div>
        <div className="h-32 w-full animate-pulse rounded bg-gray-200 object-cover" />
        <div className="absolute bottom-[-15px] left-4 z-10 flex flex-row gap-2">
          <div className="h-[30px] w-16 animate-pulse rounded-xl bg-gray-200" />
          <div className="h-[30px] w-16 animate-pulse rounded-xl bg-gray-200" />
        </div>
      </div>
    </div>
  )
}

export default UserFeedCardSkeleton
